import { Location, SetURLSearchParams } from "react-router-dom";

export const addParamToUrl = (
  location: Location,
  setSearchParams: SetURLSearchParams,
  name: string,
  value: string | number,
) => {
  const params = new URLSearchParams(location.search);
  params.append(name, String(value));
  setSearchParams(Object.fromEntries(params));
};

export const removeParamFromUrl = (location: Location, setSearchParams: SetURLSearchParams, name: string) => {
  const params = new URLSearchParams(location.search);
  params.delete(name);
  setSearchParams(Object.fromEntries(params));
};

export const getRecordIdFromSearchParams = (searchParams: URLSearchParams, name: string) => {
  const id = searchParams.get(name);
  return id && parseInt(id, 10);
};
